import type {
    AnalyticsProperties,
    AnalyticsProvider,
    PageViewProperties,
} from '../types';

/**
 * Logs analytics events to the console (development / dry-run).
 */
export class ConsoleProvider implements AnalyticsProvider {
    readonly name = 'console' as const;

    initialize(): void {
        // no-op
    }

    track(event: string, properties: AnalyticsProperties = {}): void {
        // eslint-disable-next-line no-console
        console.info('[Analytics]', { event, ...properties });
    }

    pageView(
        _path: string,
        properties: (Partial<PageViewProperties> & AnalyticsProperties) | undefined = {}
    ): void {
        // eslint-disable-next-line no-console
        console.info('[Analytics]', { event: 'screen_view', ...properties });
    }
}
